<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-power-off', fontSet: 'fad'}"
	[headerText]="T.GENERAL_TXT_LOG_OUT_OF_SIMSTATION | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="logOutShutDownCon">
			<div (click)="logOut()" class="logOutCon" mat-ripple>
				<div class="icon">
					<i class="fad fa-sign-out fa-2x"></i>
				</div>

				<div class="text">
					{{ T.GENERAL_TXT_LOG_OUT | translate }}
				</div>
			</div>

			@if (SimUtilityService.isInElectron()) {
				<div (click)="exit()" class="logOutCon" mat-ripple>
					<div class="icon">
						<i class="fad fa-power-off fa-2x"></i>
					</div>
					<div class="text">
						{{ T.GENERAL_TXT_EXIT_SIMSTATION | translate }}
					</div>
				</div>
			}
		</div>
	</ng-container>

	<ng-container actions>
		<button (click)="close({action: 'close'})" color="warn" mat-raised-button>
			{{ T.GLOBAL_TEXT_CANCEL | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
